import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/st1-logo.webp")